const MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID

export function initGtag() {
  if (!MEASUREMENT_ID) return

  window.dataLayer = window.dataLayer || []
  window.gtag = function gtag() {
    window.dataLayer.push(arguments)
  }

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`
  document.head.appendChild(script)

  window.gtag('js', new Date())
  window.gtag('config', MEASUREMENT_ID)
}

export function trackEvent(name, params) {
  try {
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, params)
    }
  } catch {
    // analytics must never break the app
  }
}
